export default __webpack_public_path__ + "static/media/ITA-pic4.cc53bd33.jpg";